import { render } from "./MyRegisterConsumer.vue?vue&type=template&id=4e405b88"
import script from "./MyRegisterConsumer.vue?vue&type=script&lang=js"
export * from "./MyRegisterConsumer.vue?vue&type=script&lang=js"

import "./MyRegisterConsumer.vue?vue&type=style&index=0&id=4e405b88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__